import { TextProps as RadixTextProps } from '@radix-ui/themes';

import { FlyThemeColor } from '../utils';

export type TextSize = '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9';

export type TextWeight = 'light' | 'regular' | 'medium' | 'semibold' | 'bold';

export type TextProps = Omit<RadixTextProps, 'color' | 'size' | 'weight'> & {
  size?: TextSize;
  color?: FlyThemeColor;
  weight?: TextWeight;
};

export const sizeToClassName: Record<TextSize, string> = {
  '1': 'text-size-fly-1',
  '2': 'text-size-fly-2',
  '3': 'text-size-fly-3',
  '4': 'text-size-fly-4',
  '5': 'text-size-fly-5',
  '6': 'text-size-fly-6',
  '7': 'text-size-fly-7',
  '8': 'text-size-fly-8',
  '9': 'text-size-fly-9',
};

export const weightToClassName: Record<TextWeight, string> = {
  light: 'font-light',
  regular: 'font-regular',
  medium: 'font-medium',
  semibold: 'font-semibold',
  bold: 'font-bold',
};
